import { Box, Link, Stack } from '@mui/material';
import Typography from 'component/MarketPlace/Typography/Typography';
import EyeBrow from 'component/MarketPlace/eyeBrow/eyeBrow';
import moment from 'moment';
import React, { memo, useMemo } from 'react';
import { ORDER_ITEM_STATUS, APPROVAL_STATUS } from '../../constant';
import { ProductDetail } from '../../types';
import { mapOrderStatus } from '../../utils';

export interface OrderedStatusProps {
  productDetail: ProductDetail;
  isApprovalPage?: boolean;
  userMarketplace?: Record<string, any>;
  assigned_approver?: string;
  approval_status?: string;
  locale: any;
  pendingApprovalDelegatedLocale?: string;
}

const OrderedStatus = ({ productDetail = {},isApprovalPage, userMarketplace, assigned_approver, approval_status, locale, pendingApprovalDelegatedLocale}: OrderedStatusProps) => {
  const orderDetailsStatus = (isApprovalPage && approval_status === ORDER_ITEM_STATUS.PENDING && assigned_approver !== userMarketplace?.email) ? productDetail?.status + `_${APPROVAL_STATUS.DELEGATED}` : productDetail?.status ;
  const orderStatus = orderDetailsStatus || '';
  const { statusText, statusColors } = mapOrderStatus(orderStatus);

  const statusDescription = useMemo(() => {
    const { status, estimated_ship_date: estimatedShipDate = {}, trackingUrl, tracking } = productDetail;
    if (!status) return null;

    switch (status) {
      case ORDER_ITEM_STATUS.ORDERED: {
        const { date, message = '' } = estimatedShipDate;
        return date ? `${locale?.expectedToShip}: ${date}` : message;
      }
      case ORDER_ITEM_STATUS.SHIPPED:
      case ORDER_ITEM_STATUS.DELIVERED: {
        return (
          <>
            {locale?.shippedOn} {moment(Date.now()).format('MMM. DD')} ·{' '}
            <Link href={trackingUrl} underline="always">
              {tracking}
            </Link>
          </>
        );
      }
      default: {
        return null;
      }
    }
  }, [productDetail]);

  return (
    <Box py={1}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        gap={1}
      >
        <EyeBrow
          id="chip-orderitem-status"
          fontSizeContent={12}
          color={statusColors.type}
          label={(isApprovalPage && approval_status === ORDER_ITEM_STATUS.PENDING && assigned_approver !== userMarketplace?.email) ? (pendingApprovalDelegatedLocale || productDetail?.status + `_${APPROVAL_STATUS.DELEGATED}`) :(locale?.commonStatus?.[productDetail?.status] || statusText || locale?.commonStatus?.other)}
          variant="filled"
          size="small"
          sx={{
            backgroundColor: statusColors.backgroundColor,
            color: statusColors.color,
            fontWeight: 600,
          }}
        />
        {statusDescription && (
          <Typography variant="subtitle2" color="text.secondary">
            {statusDescription}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default memo(OrderedStatus);
